import React from 'react';

import Select, { SelectProps } from 'antd/es/select';

import ItemsSelect from '@common/react/components/UI/ItemsSelect/ItemsSelect';
import { BaseParams } from '@common/react/objects/BaseParams';

import ColorLine from '@commonTuna/react/components/UI/ColorLine/ColorLine';

import { AppointmentType, defaultStatusesFilters } from '@app/objects/Appointment';
import { NullableAppointmentType } from '@app/components/Pages/Admin/Reports/Base/BaseReport';
import { defaultOptions } from '@app/components/UI/AppointmentType/defaultOptions';

import '@app/scss/components/statusFilter.scss';

interface ComponentProps extends SelectProps {
	value: Array<number> | undefined | string | null;
	onChange: (value: any, option) => void;
	appointmentTypes?: Array<AppointmentType>;
	antdProps?: SelectProps;
	withAdditionalOptions?: boolean;
	maxTagCount?: number;
	maxTagTextLength?: number;
	allowClear?: boolean;
	className?: string;
	valueName?: string;
	mode?: SelectProps['mode'];
	filters?: BaseParams;
	clearAfterChange?: boolean;
	filterItem?: (item) => boolean;
}

const appointmentTypeFilterOptions = (input, option: any) => {
	return (option?.item?.name ?? option?.label ?? '').toLowerCase().includes(input.toLowerCase());
};

const Option = Select.Option;

const AppointmentTypesFilter: React.FC<ComponentProps> = (props) => {
	const {
		value, onChange, maxTagCount, maxTagTextLength, antdProps, valueName = 'appointmentTypeIds', filters, clearAfterChange,
	} = props;
	const {
		withAdditionalOptions, appointmentTypes, allowClear = true, className = 'ml10 pull-right', mode = 'multiple', filterItem,
	} = props;
	const isMultiple = mode === 'multiple';

	const [innerValue, setValue] = React.useState(null);

	const handleChange = (value, option) => {
		onChange(isMultiple ? { [valueName]: value } : value, option);
		setValue(null);
	};

	return (
		<div className={`status-filter ${className}`}>
			<ItemsSelect<AppointmentType>
				{...defaultOptions}
				getOptionProps={(item) => ({
					value: item.id,
					children: <>
						<ColorLine color={item.color} />
						{item.name}
					</>,
					item,
					label: item.name,
				})}
				filterItem={filterItem}
				selectProps={{
					...antdProps,
					allowClear,
					mode: isMultiple ? 'multiple' : undefined,
					placeholder: `Appointment Type${isMultiple ? 's' : ''}...`,
					value: clearAfterChange ? innerValue : value || (isMultiple ? [] : undefined),
					onChange: handleChange,
					maxTagCount,
					maxTagTextLength,
					className: 'w100',
					filterOption: appointmentTypeFilterOptions,
					showSearch: true,
				}}
				itemsProviderSynchronizerProps={{
					objectType: 'AppointmentTypeRedux',
				}}
				items={appointmentTypes}
				filters={{ ...defaultStatusesFilters, ...filters }}
				additionalOptions={withAdditionalOptions
					? (
						<Option key={NullableAppointmentType} value={NullableAppointmentType}>
							Without type
						</Option>
					) : null}
			/>
		</div>
	);
};

export default AppointmentTypesFilter;
